<template>
  <transition name="cookie-fade">
    <div v-if="isVisible" class="cookie-banner-wrapper">
      <div class="cookie-banner-content">
        <p class="cookie-banner-text">
          Bytorg использует cookie, чтобы сайт работал стабильно и безопасно.
          Принимая, вы даете согласие на обработку файлов cookie в соответствии
          с
          <router-link :to="cookiePath" target="_blank" class="cookie-link">
            Политикой обработки файлов cookie
          </router-link>
        </p>

        <div class="cookie-banner-actions">
          <button class="btn btn-primary" @click="acceptAll">
            Принять всё
          </button>
          <button class="btn btn-outline" @click="acceptNecessary">
            Только необходимые
          </button>
          <button class="btn btn-outline" @click="openSettings">
            Настроить
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { cookiePath } from "@/router/cookie";
import { applyCookieConsent } from "@/utils/cookieConsent";

export default {
  name: "CookieBanner",
  data() {
    return {
      cookiePath,
      isVisible: false,
    };
  },
  mounted() {
    this.checkConsent();
  },
  methods: {
    checkConsent() {
      const consent = localStorage.getItem("cookie_consent");
      if (!consent) {
        this.isVisible = true;
      }
    },
    acceptAll() {
      localStorage.setItem("cookie_consent", "all");
      applyCookieConsent();
      this.isVisible = false;
    },
    acceptNecessary() {
      localStorage.setItem("cookie_consent", "necessary");
      window.location.reload();
      this.isVisible = false;
    },
    openSettings() {
      this.isVisible = false;
      this.$emit("open-settings");
    },
  },
};
</script>

<style lang="less" scoped>
.cookie-banner-wrapper {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;

  max-width: 996px;
  width: calc(100% - 32px);
  padding: 44px 32px;

  background: #484e55;
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
    0 12px 40px rgba(0, 0, 0, 0.35);
  box-sizing: border-box;

  .cookie-banner-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cookie-banner-text {
    margin: 0;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: #ffffff;

    .cookie-link {
      color: #a5d8ff;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .cookie-banner-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 32px;
    gap: 16px;

    .btn {
      flex: 1;
      height: 60px;
      border-radius: 10px;
      font-family: Montserrat, sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 100%;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.9;
      }

      &-primary {
        background: #a5d8ff;
        color: #000000;
        border: none;
      }

      &-outline {
        background: transparent;
        border: 2px solid #a5d8ff;
        color: #a5d8ff;
      }
    }
  }

  @media (max-width: 1439px) {
    width: 406px;
    max-width: calc(100% - 32px);
    padding: 32px 24px;

    .cookie-banner-text {
      font-size: 14px;
    }

    .cookie-banner-actions {
      flex-direction: column;
      align-items: center;

      .btn {
        flex: initial;
        width: 300px;
        font-size: 14px;
      }
    }
  }

  @media (max-width: 767px) {
    width: 316px;
    padding: 28px 16px;

    .cookie-banner-text {
      font-size: 14px;
    }

    .cookie-banner-actions {
      .btn {
        width: 240px;
        height: 52px;
        font-size: 14px;
      }
    }
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 20px);
}
</style>
